const Loading = () => 
<img 
src="/loading.webp"
alt="loading_circle" 
/>;

export default Loading;
